import { useRef, useState, useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import FormButton from "../../../Components/Buttons/FormButton";
import FormFileUpload from "../../../Components/FormTag/FormFileUpload";
import InputFiled from "../../../Components/FormTag/InputFiled";
import {
  itemsItemCategory,
  itemsItemGroup,
  itemsManufacturer,
  BomInformationData
} from "../../../Data/BomMaintainanceData";

import {
  ALPHANUM_REGEX,
  ALPHA_ONE_SPACE_AT_COMA_REGEX,
} from "../../../Shared/Helper/Constant";
import { PATTERN_ERR_MSG } from "../../../Shared/Helper/ValidationMessage";
import FormSelect from "../../../Components/FormTag/FormSelect";
import { bomBasicInformationType } from "./Bom.type";
import Tabs from "../../../Shared/Tab/Tab";
import PageHeader from "../../../Layout/PageHeader";

 
export default function BomBasicInfo() {
  const navigate = useNavigate();
  const [imageName, setImageName] = useState("Xbox");
  const inputFile = useRef<HTMLInputElement | null>(null);
  const [itemsBasicData, setItemsBasicData] = useState<bomBasicInformationType>(
    new bomBasicInformationType()
  );

  const {
    register,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<bomBasicInformationType>({
    defaultValues: itemsBasicData,
  });
  useEffect(() => {
    setValue('itemCode', BomInformationData[0].itemCode);
    setValue('itemDescription', BomInformationData[0].itemDescription);
    setValue('itemExtendedDescription', BomInformationData[0].itemExtendedDescription);
    setValue('EANcode', BomInformationData[0].EANcode);
    setValue('salePrice', BomInformationData[0].salePrice);
    setValue('baseCost', BomInformationData[0].baseCost);
    setValue('averageCost', BomInformationData[0].averageCost);
    setValue('itemImage', BomInformationData[0].itemImage);
    setValue('itemCategory', itemsItemCategory[0].value);
    setValue('itemGroup', itemsItemGroup[0].value);
    setValue('manufacturer', itemsManufacturer[0].value);
  }, [setValue, BomInformationData, itemsItemCategory, itemsItemGroup, itemsManufacturer]);

  const nextData: SubmitHandler<bomBasicInformationType> = (data) => {
    setItemsBasicData(data);
    reset(new bomBasicInformationType());
  };



  const handleSelectFile = (files: FileList | null) => {
    if (files) {
      const file = files[0];
      setImageName(file.name);
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64Data = reader.result as string;
        setValue("itemImage", base64Data);
        setImageName(file.name);
      };

      reader.readAsDataURL(file);
    }
  };

  const backNavigate = () => {
    return navigate(`/inventory/assembly/kitting/details/{id}`);
  };

  const handleClose = () => {
    backNavigate();
  };

  const tabs = [
    {
      order: 0,
      label: "Basic Information",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "Attribute",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: false,
    },
    {
      order: 2,
      label: "Configure Kit",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: false,
    },
    {
      order: 3,
      label: "User defined Field",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: false,
    }
  ];
  const pageName = `Kitting`;


  return (
    <>
          <PageHeader
       addUrl="/inventory/assembly/kitting/create"
       listUrl="/inventory/assembly/kitting/details/{id}"
        viewType={true}
        isHistoryEnabled={true}
      />
            <div className="clearfix"></div>
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>

    <Tabs
          tabs={tabs}
          isCheckbox={true}
          activeTabClass="d-flex flex-column"
          tabLabelClass="d-flex flex-column"
        />
      <div className="my-2 bg-white rounded py-1 px-2">
        <form>
          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Item Code</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={1}
                  autoFocus={true}
                  type="text"
                  register={register}
                  name="itemCode"
                  errors={errors.itemCode}
                  className="form-control"
                  placeholder="Enter Code"
                  required={true}
                  pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Item Description</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={2}
                  type="text"
                  register={register}
                  name="itemDescription"
                  errors={errors.itemDescription}
                  className="form-control"
                  placeholder="Enter Description"
                  required={true}
                  pattern={{
                    type: ALPHA_ONE_SPACE_AT_COMA_REGEX,
                    message: PATTERN_ERR_MSG,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Item Extended Description</label>
              <div className="mt-1"> 
                <InputFiled
                  tabIndex={3}
                  type="text"
                  register={register}
                  name="itemExtendedDescription"
                  errors={errors.itemExtendedDescription}
                  className="form-control"
                  placeholder="Field Content"
                  pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Item Category</label>
              <div className="mt-1">
                <FormSelect
                  tabIndex={5}
                  name="itemCategory"
                  control={control}
                  optionList={itemsItemCategory}
                  required={true}
                  className="form-control p-0"
                  isSearchable={true}
                />
              </div>
            </div>
          </div>
          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Item Group</label>
              <div className="mt-1">
                <FormSelect
                  tabIndex={6}
                  name="itemGroup"
                  control={control}
                  optionList={itemsItemGroup}
                  className="form-control p-0"
                  placeholder="Select"
                  isSearchable={true}
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Manufacturer</label>
              <div className="mt-1">
                <FormSelect
                  tabIndex={7}
                  name="manufacturer"
                  control={control}
                  optionList={itemsManufacturer}
                  className="form-control p-0"
                  placeholder="Select"
                  isSearchable={true}
                />
              </div>
            </div>
          </div>

          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">UPC/EAN Code</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={8}
                  type="text"
                  register={register}
                  name="EANcode"
                  errors={errors.EANcode}
                  className="form-control"
                  placeholder="Enter Code"
                  // required={true}
                  pattern={{
                    type: ALPHANUM_REGEX,
                    message: PATTERN_ERR_MSG,
                  }}
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Sale Price ($)</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={9}
                  type="text"
                  register={register}
                  name="salePrice"
                  errors={errors.salePrice}
                  className="form-control"
                  placeholder="Enter $ Price"
                  pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                />
              </div>
            </div>
          </div>

          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Base Cost ($)</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={10}
                  type="text"
                  register={register}
                  name="baseCost"
                  errors={errors.baseCost}
                  className="form-control"
                  placeholder="Enter $ Price"
                  pattern={{
                    type: ALPHA_ONE_SPACE_AT_COMA_REGEX,
                    message: PATTERN_ERR_MSG,
                  }}
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Average Cost ($)</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={11}
                  type="text"
                  register={register}
                  name="averageCost"
                  errors={errors.averageCost}
                  className="form-control"
                  placeholder="Enter $ Price"
                  pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                />
              </div>
            </div>
          </div>

          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Upload Image</label>
              <FormFileUpload
                selectFile={handleSelectFile}
                imageName={imageName}
                refType={inputFile}
                tabIndex={12}
                className="form-control"
              />
            </div>
          </div>
        </form>
      </div>

      <div className="my-2 bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={13}
            className="sph-btn me-4"
            handleClick={() => handleClose()}
          >
            Submit
          </FormButton>
          <FormButton
            tabIndex={14}
            className="sph-btn sph-shift me-4"
            handleClick={() => handleClose()}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  );
}
